import Web3 from 'web3'
import { isTronEthereumProvider } from '../tron'
// import { getGasPriceApi } from '@/api/common/chain'
// import { contractAddress, contractABI } from './config'
// import { useUserStore } from '@/store/user'

/**
 * web3 实例
 */
let web3Client = null
/**
 * 合约实例
 */
let tokenContract = null
/**
 * 当前钱包地址
 */
let currentAddress = ''

function ethereumProviders() {
  if (typeof window === 'undefined' || typeof window.ethereum === 'undefined') {
    return []
  }
  return Array.isArray(window.ethereum.providers)
    ? window.ethereum.providers
    : [window.ethereum]
}

export function isDistinctEthereumProvider(provider) {
  if (!provider || typeof provider.request !== 'function') {
    return false
  }
  // 有独立 EVM 注入就算 ETH 可用。同时注入了波场也不排除，交给选链。
  return !isTronEthereumProvider(provider)
}

export function hasDistinctEthereumWallet() {
  return ethereumProviders().some(isDistinctEthereumProvider)
}

/**
 * 检验独立的以太坊钱包。TronLink 注入的 window.ethereum 不算。
 */
export const check = async () => {
  return hasDistinctEthereumWallet()
}

/**
 * 检查并切换到ETH主网
 */
const validateAndSwitchToMainnet = async () => {
  try {
    // 获取当前网络
    const chainId = await window.ethereum.request({ method: 'eth_chainId' })
    console.log('当前网络:', chainId)

    // 如果已经是ETH主网，直接返回成功
    if (chainId === '0x1') {
      return { success: true, message: 'Already on Ethereum Mainnet' }
    }

    // 不是ETH主网，尝试自动切换
    console.log('检测到非ETH主网，尝试自动切换...')
    try {
      await window.ethereum.request({
        method: 'wallet_switchEthereumChain',
        params: [{ chainId: '0x1' }]
      })
      console.log('自动切换到ETH主网成功')
      return { success: true, message: 'Successfully switched to Ethereum Mainnet' }
    } catch (switchError) {
      console.log('自动切换失败:', switchError)

      // 用户拒绝切换
      if (switchError.code === 4001) {
        return {
          success: false,
          error: 'USER_REJECTED',
          message: 'Please Switch to Ethereum Mainnet to Continue.'
        }
      }

      // 其他切换错误
      return {
        success: false,
        error: 'SWITCH_FAILED',
        message: 'Please Switch to Ethereum Mainnet to Continue.'
      }
    }
  } catch (error) {
    console.error('网络验证失败:', error)
    return {
      success: false,
      error: 'VALIDATION_FAILED',
      message: 'Please Switch to Ethereum Mainnet to Continue.'
    }
  }
}

/**
 * 请求连接钱包（增强版本，包含网络验证）
 */
export const connect = async () => {
  let result = { code: 200 }
  let isChecked = await check()
  if (isChecked) {
    web3Client = new Web3(window.ethereum)

    try {
      // 1. 先验证和切换网络
      const networkResult = await validateAndSwitchToMainnet()
      if (!networkResult.success) {
        result.code = 500
        result.msg = networkResult.message
        result.networkError = true
        return result
      }

      // 2. 网络验证通过，请求连接钱包
      const requestAccounts = await window.ethereum.request({ method: 'eth_requestAccounts' })
      if (requestAccounts.length) {
        currentAddress = requestAccounts[0]
        result.data = { type: 'ETH', address: currentAddress }
      }
    } catch (error) {
      // 连接账户出错
      console.log(error)
      result.code = 500
      result.msg = error.message
    }
  }
  return result
}
/**
 * 初始化网络切换监听
 */
export const initNetworkWatcher = async () => {
  let checked = await check()
  if (checked) {
    window.ethereum.on('chainChanged', async (chainId) => {
      console.log('🔗 网络已切换到:', chainId)

      // 检查用户是否已登录
      const isLogin = localStorage.getItem('isLogin') === 'true'
      const hasToken = localStorage.getItem('token')

      if (isLogin && hasToken) {
        console.log('👤 检测到已登录用户切换网络')

        // 如果不是ETH主网，清除登录状态并跳转
        if (chainId !== '0x1') {
          console.log('🚨 切换到非ETH主网，清除登录状态')

          // 清除登录状态
          localStorage.removeItem('isLogin')
          localStorage.removeItem('token')
          localStorage.removeItem('userInfo')
          localStorage.removeItem('address')

          // 清除store状态
          if (window.vm && window.vm.$store) {
            window.vm.$store.commit('SET_LOGIN', false)
            window.vm.$store.commit('SET_USER_INFO', {})
          }

          // 跳转到empty页面
          if (window.vm && window.vm.$router) {
            window.vm.$router.push('/empty')
          } else {
            window.location.href = '/empty'
          }

          // 显示提示
          if (window.vm && window.vm.$message) {
            window.vm.$message.warning('Please Switch to Ethereum Mainnet to Continue.')
          }
        }
      }
    })

    console.log('🔍 网络监听器已初始化')
  }
}

//     window.ethereum.on('disconnect', (code, reason) => {
//       // 断开连接
//       console.log('disconnect', code, reason)
//     })
//   }
// }
// /**
//  * 获取 GasPrice
//  */
// export const getGasPrice = async () => {
//   let tempGasPrice = 7e4
//   // 获取当前 Gas 价格
//   const gasPrice = await web3Client.eth.getGasPrice()
//   if (gasPrice) {
//     tempGasPrice = parseInt(gasPrice) * 2
//   }

//   console.log('gasPrice', gasPrice)
//   // try {
//   //   const res = await getGasPriceApi()
//   //   if (res && res.code == 0) {
//   //     let tempData = JSON.parse(res.data)
//   //     if (tempData && tempData.FastGasPrice) {
//   // web3Client.utils.toWei(tempData.FastGasPrice.toString(), 'gwei')
//   //       sendParams.gasPrice = parseInt(tempData.FastGasPrice * 1e9)
//   //     }
//   //   }
//   // } catch (error) {
//   //   console.log('getGasPrice——error', error)
//   // }
//   return tempGasPrice
// }

// /**
//  * 合约授权
//  */
// export const approve = async (spenderAddress, type = 'USDT') => {
//   await connect()

//   if (!tokenContract) {
//     tokenContract = new web3Client.eth.Contract(contractABI, contractAddress[type])
//   }
//   // 代币的小数位数
//   const tokenDecimals = BigInt(18)
//   // 希望授权的代币数量
//   const tokenAmountToApprove = BigInt(999000000000)
//   // 授权数量
//   const amountToAuthorize = web3Client.utils.toHex(
//     tokenAmountToApprove * BigInt(10) ** tokenDecimals
//   )

//   let sendParams = {
//     from: currentAddress, //当前钱包地址
//     gas: 7e4
//   }
//   // sendParams.gasPrice = parseInt(tempData.FastGasPrice * 1e9)
//   sendParams.gasPrice = await getGasPrice()
//   // 调用合约的 approve 方法进行授权
//   return {
//     approveMethod: tokenContract.methods.approve(spenderAddress, amountToAuthorize).send(sendParams)
//   }
// }
